import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

import { MARGIN_TOP } from './constants';
import { ISectionContainerProps } from './types';

export const Section = styled.section<ISectionContainerProps>`
  margin: 0 auto;
  margin-top: ${primitive.$spacing4};
  ${({ addPadding }) => addPadding && MARGIN_TOP};
  width: calc(100% ${({ $fullWidth }) => ($fullWidth ? '' : '- ${primitive.$spacing7}')});
  ${Styles.desktop`
    ${({ addPadding }: ISectionContainerProps) => addPadding && 'margin: 0 auto;'};
    max-width: 1050px;
  `};
`;
